import React, { FC } from "react";
import CoreButtons from "../../button/CoreButtons";
import { iModalFooterProps } from "../../../../types/modalBoxType";

const ModalFooter: FC<iModalFooterProps> = ({
	className,
	buttonText,
	variant,
	color,
	coreBtnPill,
	fullWidth,
	disabled,
	onclick,
	children,
	modalFooterClassName,
}) => {
	return (
		<div className={modalFooterClassName}>
			<CoreButtons
				className={className}
				buttonText={buttonText}
				variant={variant}
				color={color}
				coreBtnPill={coreBtnPill}
				fullWidth={fullWidth}
				disabled={disabled}
				onclick={onclick}
				sx={{ textTransform: "none" }}
			/>
			{children}
		</div>
	);
};
export default ModalFooter;
